import React, { useState } from "react"
import clsx from "classnames"

interface SwitchProps {
  checked: boolean
  label?: string
  /**
   * Callback function when the switch is toggled.
   * @param isChecked
   */
  onChange: (isChecked: boolean) => void
}

/**
 * The switch component represents a boolean value that can be toggled on or off.
 */
export const Switch = ({ label = "", checked = false, onChange, ...rest }: SwitchProps) => {
  const [focused, setFocused] = useState(false)

  const switchClasses = clsx(
    "relative h-6 w-11 rounded-full bg-gray-200 peer-checked:bg-gray-800 after:absolute after:start-[2px] after:top-[2px] after:size-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-full peer-checked:after:border-white",
    {
      "border-4 border-solid border-red-300": focused,
    },
  )

  return (
    <label className="inline-flex cursor-pointer items-center">
      <input
        type="checkbox"
        className="peer sr-only"
        checked={checked}
        aria-label={label}
        onChange={() => onChange?.(!checked)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        {...rest}
      />

      <div aria-checked={checked} className={switchClasses}></div>
      {label ? <span className="ms-3 text-lg text-black">{label}</span> : null}
    </label>
  )
}
